import { wireAreaFromDiameter } from "../weldParameter/formulas";
import type { WireConversionInputs, WireConversionResult } from "./types";

export function calculateWireConversion(inputs: WireConversionInputs): WireConversionResult {
  const sourceArea = wireAreaFromDiameter(inputs.sourceDiameter);
  const targetArea = wireAreaFromDiameter(inputs.targetDiameter);
  const volumeRate = sourceArea * inputs.sourceWireFeed * 1000;
  const ratio = sourceArea / targetArea;

  return {
    targetWireFeed: inputs.sourceWireFeed * ratio,
    sourceArea,
    targetArea,
    volumeRate,
    ratio
  };
}
